'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  ATTEMPTED_REFUND_INDIVIDUAL: null,
  ATTEMPTED_REFUND_PACK: null,
  ATTEMPTED_UNINSTALL_INDIVIDUAL: null,
  ATTEMPTED_UNINSTALL_PACK: null,
  SEE_WHERE_IN_USE: null
});